import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<Ui::Page class=\"!px-0\">\n  {{outlet}}\n</Ui::Page>",{ moduleName: "garaje/pods/employees/document-review/template.hbs" })